export * from './src/events-v3-event-wix-events-v-2.meta.js';
